import request from './request';
import { setMemberStore, memberStore } from './state';
import { useRouter } from "vue-router";
import { inIframe } from "@/common/tools";

export function authGuard(to: any, from: any, next: any) {
    let member: any = memberStore.member;
    const runtimeConfig = (window as any) || {};
    const openOAuthU = getQueryVariable('openOAuth')
    const openOAuth = openOAuthU || runtimeConfig.openOAuth || false;
    const client_id = runtimeConfig.client_id || '';
    const OAuthUrl = runtimeConfig.OAuthUrl || '';

    let token = localStorage.getItem('token') || sessionStorage.getItem('token');
    let isInIframe = inIframe();
    let useSessionInIframe = runtimeConfig.useSessionJwtInIframe ?? true
    if (isInIframe && useSessionInIframe) {
        token = sessionStorage.getItem("token") || "";
        console.log('use session token storage in iframe')
    } else {
        token = localStorage.getItem("token") || sessionStorage.getItem("token") || "";
    } 
    
    if (member || token) {
        if (!member) {
            request.get('/api/members/info').then((res) => {
                if (res) {
                    //sessionStorage.setItem('user', JSON.stringify(res.data));
                    setMemberStore(res.data);
                    next();
                } else {
                    var code = getQueryVariable('code')
                    if ((openOAuth || code) && OAuthUrl && client_id) {// OAuth 2.0 authorization mode
                        if (code) {
                            const currentUrl = window.location.origin + '/';
                            const config = {
                                params: { code: code, redirect_uri: currentUrl },
                                headers: {},
                            };
                            // Validate code
                            request.get('/api/accesstoken', config).then((res) => {
                                if (res) {
                                    localStorage.setItem("token", res.data);
                                    sessionStorage.setItem("token", res.data);
                                    setMemberStore(null)
                                    next('/');
                                } else {
                                    next('/login');
                                }
                            })
                        } else {
                            // Get the current URL
                            const currentUrl = window.location.origin + '/';
                            // Escape the URL
                            const redirect_uri = encodeURIComponent(currentUrl);
                            window.location.href = OAuthUrl + '?client_id=' + client_id + "&response_type=code&redirect_uri=" + redirect_uri// Redirect to login authorization
                            // next(); // Redirect to login
                        }
                    } else {
                        next('/login'); // Redirect to login
                    }
                }
            })
        } else {
            member.menuIds = member?.menus?.map((t: any) => (t.id))
            member.factoryIds = member?.factories.map((t: any) => (t.id))
            next();
        }
    } else {
        var code = getQueryVariable('code')
        if ((openOAuth || code) && OAuthUrl && client_id) {// OAuth 2.0 authorization mode
            if (code) {
                const currentUrl = window.location.origin + '/';
                const config = {
                    params: { code: code, redirect_uri: currentUrl },
                    headers: {},
                };
                // Validate code
                request.get('/api/accesstoken', config).then((res) => {
                    if (res) {
                        localStorage.setItem("token", res.data);
                        sessionStorage.setItem("token", res.data);
                        setMemberStore(null)
                        next('/');
                    } else {
                        next('/login');
                    }
                })
            } else {
                // Get the current URL
                const currentUrl = window.location.origin + '/';
                // Escape the URL
                const redirect_uri = encodeURIComponent(currentUrl);
                window.location.href = OAuthUrl + '?client_id=' + client_id + "&response_type=code&redirect_uri=" + redirect_uri// Redirect to login authorization
                // next(); // Redirect to login
            }
        } else {
            next('/login'); // Redirect to login
        }

    }
}

function getQueryVariable(variable: any) {
    if (window.location.href.indexOf("?") < 0 || window.location.href.indexOf(variable) < 0) {
        return false
    }
    // Get the query string from the current URL (the part after the question mark)
    var query = window.location.href.split('?')[1];
    // Split the query string into an array by &
    var vars = query.split("&");
    // Iterate over each element in the array
    for (var i = 0; i < vars.length; i++) {
        // Split the current element into key and value by =
        var pair = vars[i].split("=");
        // If the current key matches the parameter name, return its value
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    // Return false if no matching parameter name is found
    return false;
}
